module.exports = __webpack_public_path__ + "media/theme/zigzag--white-b8186633.png";